import { createReducer, on } from '@ngrx/store';
import { News } from '../../models';
import * as actions from '../actions/featured-news.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';

export interface FeaturedNewsState {
  entities: { [id: number]: News };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: FeaturedNewsState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const FeaturedNewsReducer = createReducer(
  initialState,

  on(actions.LoadFeaturedNews, (state: FeaturedNewsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.LoadFeaturedNewsSuccess, (state: FeaturedNewsState, { news }) => {
    const entities = ToEntities(news, 'id', {});

    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(actions.LoadFeaturedNewsFail, (state: FeaturedNewsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getFeaturedNewsEntities = (state: FeaturedNewsState) => state.entities;
export const getFeaturedNewsLoading = (state: FeaturedNewsState) => state.loading;
export const getFeaturedNewsLoaded = (state: FeaturedNewsState) => state.loaded;
export const getFeaturedNewsError = (state: FeaturedNewsState) => state.error;
